
    import { WebSale } from '@/apps/shared/models/webSale';
    import { defineComponent } from 'vue'
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import calculatorPRETService from '@/apps/shared/services/calculatorPRET-service';
    import { SaveMultiQuoteNotificationsRequest } from '@/apps/shared/models/saveMultiQuoteNotificationsRequest';
    import saveMultiQuoteNotificationsService from '@/apps/shared/services/saveMultiQuoteNotifications-service';
    export default defineComponent({
        components: {
            XBreadcrumb
        },
        busEvents: {
            updateLogo(newLogo) {
                this.navbar.logo = '/Logos/retiro.png';
            },
        },
        data() {
            return {
                formato: new Intl.NumberFormat('de-DE', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                }),
                max: 400000,
                min: 40000,
                step: 5000,
                maxUsd: 400,
                minUsd: 100,
                stepUsd: 10,
                ageMin: 18,
                age: 18,
                currencyText: "ARS",
                valueARS: 40000,
                valueUSD: 100,
                quantity: 5,
                genderType: 0,
                currencyType: 0,
                retirementCapital: null,
                monthlyRent: null,
                clientData: null as any,
                webSaleData: null as WebSale | null,
                savedNotificationNumber: null as number | null,
                isInterestedDisabled: sessionStorage.getItem("InterestedDisabled") === "1",
                notified: false,
                pendingChanges: false,
                breadcrumItems: [
                    { text: 'Inicio', path: '/calculadoraretiro' },
                    { text: 'Calculadora Retiro', path: '/calculadoraretiro/cotizarRetiro' },
                ],
            }
        },

        computed: {
            showInterestedButton(): boolean {
                try {
                    const webSale: WebSale | null = (this.$store && this.$store.getters) ? this.$store.getters.getWebSaleData : null;
                    if (!webSale) return false;

                    // Evaluar que el cliente no sea un asesor
                    const code = (webSale as any).clientCode ?? (webSale as any).ClientCode ?? null;
                    if (code === null || code === undefined) return false;

                    const numeric = Number(code);
                    if (Number.isNaN(numeric)) return false;

                    // Código de asesor = 5.
                    return numeric !== 5;
                } catch {
                    return false;
                }
            }
        },

        methods: {
            // Cambios pendientes de simulación/cotización
            markPendingChanges() {
                if (this.isInterestedDisabled || this.notified) {
                    this.pendingChanges = true;
                }
            },

            async calculate() {
                const defaultTitle = 'Retiro';
                const genderT = this.genderType == 0 ? "M" : "F";
                const genderName = this.genderType == 0 ? "Masculino" : "Femenino";
                const value = this.currencyType == 0 ? this.valueARS : this.valueUSD;
                const resp = await calculatorPRETService.calculatePRET(genderT, this.age, this.currencyText, value);

                this.monthlyRent = resp.monthlyRent;
                this.retirementCapital = resp.retirementCapital;

                // guardo clientData y webSaleData para poder tomarla de otros métodos
                try {
                    const parsed = JSON.parse(sessionStorage.getItem("DataClient") || 'null');
                    this.clientData = parsed || null;
                } catch (e) {
                    this.clientData = null;
                }

                this.webSaleData = (this.$store && this.$store.getters) ? this.$store.getters.getWebSaleData : null;

                if (this.webSaleData) {
                    const request = new SaveMultiQuoteNotificationsRequest();
                    if (this.clientData) {
                        request.lastName = this.clientData.lastName;
                        request.firstName = this.clientData.firstName;
                        request.phone = (this.clientData.areaCode || '') + (this.clientData.telephone || '');
                        request.mail = this.clientData.email;
                    }
                    request.quotePlan = "Prev. Retiro";
                    request.quotationDetail =
                        "Producto: " + defaultTitle
                        + " - Identificación: " + genderName
                        + " - Edad: " + this.age
                        + " - Moneda: " + this.currencyText
                        + " - Ahorro mensual: "
                        + this.formatAmount(value, this.currencyText);

                    // Capturo la respuesta para obtener el NotificationNumber
                    try {
                        const saveResp = await saveMultiQuoteNotificationsService.saveMultiQuoteNotifications(request);
                        if (saveResp && typeof saveResp.notificationNumber !== 'undefined') {
                            this.savedNotificationNumber = saveResp.notificationNumber;
                            sessionStorage.setItem("NotificationNumber", String(this.savedNotificationNumber));
                        }

                        // Si hay cambios pendientes de simulación/cotización
                        if (this.pendingChanges) {
                            this.isInterestedDisabled = false;
                            this.notified = false;
                            try {
                                sessionStorage.removeItem("InterestedDisabled");
                            } catch {
                            }
                            this.pendingChanges = false;
                        }
                    } catch (err) {
                        // No interrumpimos la UX por fallo en el guardado de la notificación
                        console.error('Error al guardar el número de notificación en calculate:', err);
                    }
                }
            },

            // Muestra el modal de leyenda y actualiza notificación con quotationState = "Contratado"
            async showInterestedModal() {
                try {
                    const defaultTitle = 'Retiro';

                    // Si hay datos de cliente y oferta
                    if (!this.clientData) {
                        try {
                            this.clientData = JSON.parse(sessionStorage.getItem("DataClient") || 'null') || null;
                        } catch (e) {
                            this.clientData = null;
                        }
                    }
                    if (!this.webSaleData && this.$store && this.$store.getters) {
                        this.webSaleData = this.$store.getters.getWebSaleData;
                    }

                    const genderName = this.genderType == 0 ? "Masculino" : "Femenino";
                    const value = this.currencyType == 0 ? this.valueARS : this.valueUSD;

                    const request = new SaveMultiQuoteNotificationsRequest();

                    if (this.clientData) {
                        request.lastName = this.clientData.lastName;
                        request.firstName = this.clientData.firstName;
                        request.phone = (this.clientData.areaCode || '') + (this.clientData.telephone || '');
                        request.mail = this.clientData.email;
                    } else {
                        console.warn('showInterestedModal: faltan datos necesarios de cliente');
                    }

                    request.quotePlan = "Prev. Retiro";
                    request.quotationDetail =
                        "Producto: " + defaultTitle
                        + " - Identificación: " + genderName
                        + " - Edad: " + this.age
                        + " - Moneda: " + this.currencyText
                        + " - Ahorro mensual: "
                        + this.formatAmount(value, this.currencyText);

                    request.quotationState = "Contratado";

                    // Si se guardó notificationNumber en calculate
                    if (this.savedNotificationNumber != null) {
                        request.notificationNumber = this.savedNotificationNumber;
                    } else {
                        // si no hay, se intenta recuperar de sesión
                        const nnFromSession = sessionStorage.getItem("NotificationNumber");
                        if (nnFromSession) {
                            const parsed = Number(nnFromSession);
                            if (!Number.isNaN(parsed)) {
                                request.notificationNumber = parsed;
                                this.savedNotificationNumber = parsed;
                            }
                        }
                    }

                    // Ejecutar save; si se completa sin excepción marcamos éxito para luego deshabilitar el botón al cerrar modal
                    try {
                        await saveMultiQuoteNotificationsService.saveMultiQuoteNotifications(request);
                        this.notified = true;
                    } catch (err) {
                        this.notified = false;
                        console.error('Error al guardar notificación "Me interesa":', err);
                    }
                } catch (error) {
                    console.error('Error al preparar notificación "Me interesa":', error);
                } finally {
                    (this.$refs.interestedModal as any)?.open();
                }
            },

            closeInterestedModal() {
                // Si el guardado en showInterestedModal fue exitoso, deshabilitamos el botón y persistimos en sesión
                if (this.notified) {
                    this.isInterestedDisabled = true;
                    try {
                        sessionStorage.setItem("InterestedDisabled", "1");
                    } catch {
                    }
                }

                (this.$refs.interestedModal as any)?.close();
            },

            formatAmount(value: number, currency: "ARS" | "USD"): string {
                if (currency === "USD") {
                    return `US$ ${Math.round(value).toLocaleString("es-AR", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    })}`;
                }

                // ARS
                return `$ ${value.toLocaleString("es-AR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })}`;
            },

            addQuantity() {
                this.quantity++;
            },
            restAge() {
                if (this.age >= 2) {
                    this.age--;
                }
            },

            addAge() {
                this.age++;
            },

            async pageCustomization() {
                const defaultTitle = 'Seguro de Retiro';
                const actualPath = '/calculadoraretiro'

                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, '', null);
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },
        },
        watch: {
            genderType(newVal, oldVal) {
                // Cambio en el sexo seleccionado
                if (newVal !== oldVal) {
                    this.age = 18;
                    this.markPendingChanges();
                }
            },
            
            // Cambio en moneda
            currencyType(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.currencyText = Number(newVal) === 0 ? "ARS" : "USD";
                    this.markPendingChanges();
                }
            },

            // Cambio en edad
            age(newVal, oldVal) {
                if (newVal !== oldVal){ 
                    this.markPendingChanges()
                }
            },
            
            // Cambio en ahorro en pesos
            valueARS(newVal, oldVal) {
                if (newVal !== oldVal){
                    this.markPendingChanges();
                }
            },
            
            // Cambio en ahorro en dólares
            valueUSD(newVal, oldVal) {
                if (newVal !== oldVal){
                    this.markPendingChanges();
                    }
            }
        },
        async mounted() {
            try {
                NF.UI.Page.block();

                this.pageCustomization();

                sessionStorage.setItem("ExitOrContinueModal", "true");
            } finally {
                NF.UI.Page.unblock();
            }
        },
    })
